// Keyboard layouts for different languages
// Reference: https://github.com/hodgef/simple-keyboard-layouts

export const englishLayout = {
  default: [
    '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
    '{tab} q w e r t y u i o p [ ] \\',
    "{lock} a s d f g h j k l ; ' {enter}",
    '{shift} z x c v b n m , . / {shift}',
    '{space}',
  ],
  shift: [
    '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
    '{tab} Q W E R T Y U I O P { } |',
    '{lock} A S D F G H J K L : " {enter}',
    '{shift} Z X C V B N M < > ? {shift}',
    '{space}',
  ],
};

export const hindiLayout = {
  default: [
    '` १ २ ३ ४ ५ ६ ७ ८ ९ ० - ृ {bksp}',
    '{tab} ौ ै ा ी ू ब ह ग द ज ड ़ ॉ',
    '{lock} ो े ् ि ु प र क त च ट {enter}',
    '{shift} ं म न व ल स , . य {shift}',
    '{space}',
  ],
  shift: [
    '~ ऍ ॅ ् र ज्ञ त्र क्ष श्र ( ) ः ऋ {bksp}',
    '{tab} औ ऐ आ ई ऊ भ ङ घ ध झ ढ ञ ऑ',
    '{lock} ओ ए अ इ उ फ ऱ ख थ छ ठ {enter}',
    '{shift} ँ ण न ळ ळ श ष । य़ {shift}',
    '{space}',
  ],
};

export const gujaratiLayout = {
  default: [
    '` ૧ ૨ ૩ ૪ ૫ ૬ ૭ ૮ ૯ ૦ - ૃ {bksp}',
    '{tab} ૌ ૈ ા ી ૂ બ હ ગ દ જ ડ ઼',
    '{lock} ો ે ્ િ ુ પ ર ક ત ચ ટ {enter}',
    '{shift} ં મ ન વ લ સ , . ય {shift}',
    '{space}',
  ],
  shift: [
    '~ ઍ ૅ ્ ર જ્ઞ ત્ર ક્ષ શ્ર ( ) ઃ ઋ {bksp}',
    '{tab} ઔ ઐ આ ઈ ઊ ભ ઙ ઘ ધ ઝ ઢ ઞ',
    '{lock} ઓ એ અ ઇ ઉ ફ ખ થ છ ઠ {enter}',
    '{shift} ઁ ણ ળ શ ષ । {shift}',
    '{space}',
  ],
};

export const marathiLayout = {
  default: [
    '` १ २ ३ ४ ५ ६ ७ ८ ९ ० - ृ {bksp}',
    '{tab} ौ ै ा ी ू ब ह ग द ज ड ़ ॉ',
    '{lock} ो े ् ि ु प र क त च ट {enter}',
    '{shift} ं म न व ळ स , . य {shift}',
    '{space}',
  ],
  shift: [
    '~ ऑ ॅ ् र ज्ञ त्र क्ष श्र ( ) ः ऋ {bksp}',
    '{tab} औ ऐ आ ई ऊ भ ङ घ ध झ ढ ञ ऑ',
    '{lock} ओ ए अ इ उ फ ऱ ख थ छ ठ {enter}',
    '{shift} ँ ण न ळ श ष । {shift}',
    '{space}',
  ],
};

export const teluguLayout = {
  default: [
    '` 1 2 3 4 5 6 7 8 9 0 - ృ {bksp}',
    '{tab} ౌ ై ా ీ ూ బ హ గ ద జ డ',
    '{lock} ో ే ్ ి ు ప ర క త చ ట {enter}',
    '{shift} ం మ న వ ల స , . య {shift}',
    '{space}',
  ],
  shift: [
    '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
    '{tab} ఔ ఐ ఆ ఈ ఊ భ ఙ ఘ ధ ఝ ఢ',
    '{lock} ఓ ఏ అ ఇ ఉ ఫ ఱ ఖ థ ఛ ఠ {enter}',
    '{shift} ఁ ణ ళ శ ష {shift}',
    '{space}',
  ],
};

export const tamilLayout = {
  default: [
    '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
    '{tab} ஔ ஐ ஆ ஈ ஊ ப ஹ க த ச ட',
    '{lock} ஓ ஏ அ இ உ ப ர க த ச ட {enter}',
    '{shift} ஂ ம ந வ ல ஸ , . ய {shift}',
    '{space}',
  ],
  shift: [
    '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
    '{tab} ஔ ஐ ஆ ஈ ஊ ப ஹ க த ச ட',
    '{lock} ஓ ஏ அ இ உ ப ர க த ச ட {enter}',
    '{shift} ங ண ன ழ ள ஷ ஜ ஶ ஞ {shift}',
    '{space}',
  ],
};

export const bengaliLayout = {
  default: [
    '` ১ ২ ৩ ৪ ৫ ৬ ৭ ৮ ৯ ০ - ৃ {bksp}',
    '{tab} ৌ ৈ া ী ূ ব হ গ দ জ ড ়',
    '{lock} ো ে ্ ি ু প র ক ত চ ট {enter}',
    '{shift} ং ম ন ব ল স , . য {shift}',
    '{space}',
  ],
  shift: [
    '~ ! @ # ৎ % ^ & * ( ) _ + {bksp}',
    '{tab} ঔ ঐ আ ঈ ঊ ভ ঙ ঘ ধ ঝ ঢ ঞ',
    '{lock} ও এ অ ই উ ফ ড় খ থ ছ ঠ {enter}',
    '{shift} ঁ ণ ন ব ল শ ষ । য় {shift}',
    '{space}',
  ],
};

export const numpadLayout = {
  default: ['1 2 3', '4 5 6', '7 8 9', '. 0 {bksp}'],
};

// Language display names
export const languageNames: Record<string, string> = {
  english: 'EN',
  hindi: 'हि',
  gujarati: 'ગુ',
  marathi: 'म',
  telugu: 'తె',
  // tamil: 'த',
  // bengali: 'বা',
};

// All layouts mapped by language key
export const layouts: Record<string, { default: string[]; shift?: string[] }> = {
  english: englishLayout,
  hindi: hindiLayout,
  gujarati: gujaratiLayout,
  marathi: marathiLayout,
  telugu: teluguLayout,
  // tamil: tamilLayout,
  // bengali: bengaliLayout,
  numpad: numpadLayout,
};
